module.exports = __webpack_public_path__ + "catalog/items/baño_39/3.9.jpg";